/**
 * SmartdineNow API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs';

import { OfferMappingModel } from '../model/offerMappingModel';
import { SmartDineResponseOfferMappingModel } from '../model/smartDineResponseOfferMappingModel';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class OfferMappingRestControllerService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOfferMappings(body: OfferMappingModel, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferMappingModel>;
    public createOfferMappings(body: OfferMappingModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferMappingModel>>;
    public createOfferMappings(body: OfferMappingModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferMappingModel>>;
    public createOfferMappings(body: OfferMappingModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createOfferMappings.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseOfferMappingModel>('post',`${this.basePath}/api/admin/offermappings`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param offerMappingId 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferMappingModel>;
    public deleteOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferMappingModel>>;
    public deleteOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferMappingModel>>;
    public deleteOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (offerMappingId === null || offerMappingId === undefined) {
            throw new Error('Required parameter offerMappingId was null or undefined when calling deleteOfferMapping.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling deleteOfferMapping.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseOfferMappingModel>('delete',`${this.basePath}/api/admin/offermappings/${encodeURIComponent(String(offerMappingId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param offerMappingId 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferMappingModel>;
    public getOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferMappingModel>>;
    public getOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferMappingModel>>;
    public getOfferMapping(offerMappingId: string, restaurantId: string, restaurantBranchId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (offerMappingId === null || offerMappingId === undefined) {
            throw new Error('Required parameter offerMappingId was null or undefined when calling getOfferMapping.');
        }

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getOfferMapping.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseOfferMappingModel>('get',`${this.basePath}/api/admin/offermappings/${encodeURIComponent(String(offerMappingId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param restaurantId 
     * @param restaurantBranchId 
     * @param offerRuleId 
     * @param menuItemMapId 
     * @param menuId 
     * @param userId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOfferMappings(restaurantId: string, restaurantBranchId?: string, offerRuleId?: string, menuItemMapId?: string, menuId?: string, userId?: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferMappingModel>;
    public getOfferMappings(restaurantId: string, restaurantBranchId?: string, offerRuleId?: string, menuItemMapId?: string, menuId?: string, userId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferMappingModel>>;
    public getOfferMappings(restaurantId: string, restaurantBranchId?: string, offerRuleId?: string, menuItemMapId?: string, menuId?: string, userId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferMappingModel>>;
    public getOfferMappings(restaurantId: string, restaurantBranchId?: string, offerRuleId?: string, menuItemMapId?: string, menuId?: string, userId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (restaurantId === null || restaurantId === undefined) {
            throw new Error('Required parameter restaurantId was null or undefined when calling getOfferMappings.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (restaurantId !== undefined && restaurantId !== null) {
            queryParameters = queryParameters.set('restaurantId', <any>restaurantId);
        }
        if (restaurantBranchId !== undefined && restaurantBranchId !== null) {
            queryParameters = queryParameters.set('restaurantBranchId', <any>restaurantBranchId);
        }
        if (offerRuleId !== undefined && offerRuleId !== null) {
            queryParameters = queryParameters.set('offerRuleId', <any>offerRuleId);
        }
        if (menuItemMapId !== undefined && menuItemMapId !== null) {
            queryParameters = queryParameters.set('menuItemMapId', <any>menuItemMapId);
        }
        if (menuId !== undefined && menuId !== null) {
            queryParameters = queryParameters.set('menuId', <any>menuId);
        }
        if (userId !== undefined && userId !== null) {
            queryParameters = queryParameters.set('userId', <any>userId);
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SmartDineResponseOfferMappingModel>('get',`${this.basePath}/api/admin/offermappings`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param offerMappingId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateOfferMapping(body: OfferMappingModel, offerMappingId: string, observe?: 'body', reportProgress?: boolean): Observable<SmartDineResponseOfferMappingModel>;
    public updateOfferMapping(body: OfferMappingModel, offerMappingId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmartDineResponseOfferMappingModel>>;
    public updateOfferMapping(body: OfferMappingModel, offerMappingId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmartDineResponseOfferMappingModel>>;
    public updateOfferMapping(body: OfferMappingModel, offerMappingId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateOfferMapping.');
        }

        if (offerMappingId === null || offerMappingId === undefined) {
            throw new Error('Required parameter offerMappingId was null or undefined when calling updateOfferMapping.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SmartDineResponseOfferMappingModel>('put',`${this.basePath}/api/admin/offermappings/${encodeURIComponent(String(offerMappingId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
